import styles from '../globals/pages.module.scss'

import { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { apiErrors } from '../helpers/apiErrors'
import HearingLossSignForm from '../components/hearingLossSignForm/main'
import { FormPageLoading } from '../components/ui/FormPageLoading'
import BrandBar from '../components/ui/BrandBar'
import { useUpdateClaimData } from '../claimProvider'

const MOCK_PACK_DOCS = [
    {
        id: 'bridging-agreement',
        title: 'Bridging Agreement',
        url: 'https://pdfobject.com/pdf/sample.pdf',
    },
    {
        id: 'conditional-fee-agreement',
        title: 'Conditional Fee Agreement',
        url: 'https://pdfobject.com/pdf/sample.pdf',
    },
    {
        id: 'pre-action-contingency-fee',
        title: 'Pre-Action Contingency Fee Agreement',
        url: 'https://pdfobject.com/pdf/sample.pdf',
    },
    {
        id: 'foa-service-records',
        title: 'Form of Authority — Service Records',
        url: 'https://pdfobject.com/pdf/sample.pdf',
    },
    {
        id: 'mod-sar-request',
        title: 'MOD Subject Access Request',
        url: 'https://pdfobject.com/pdf/sample.pdf',
    },
    {
        id: 'civilian-medical-consent',
        title: 'Civilian Medical Records Consent',
        url: 'https://pdfobject.com/pdf/sample.pdf',
    },
    {
        id: 'hmrc-employment-history',
        title: 'HMRC Employment History',
        url: 'https://pdfobject.com/pdf/sample.pdf',
    },
]

const resumeGroup = (payload: any): 'signature' | 'upload' | 'complete' => {
    const step = payload?.next_step || payload?.sigData?.next_step
    if (step === 'upload' || step === 'complete' || step === 'signature') return step
    const signed = payload?.signed === true || Number(payload?.sigData?.signed) === 1
    const identity = payload?.identity || payload?.sigData?.identity || {}
    if (!signed) return 'signature'
    if (identity.poid && identity.utility_bill) return 'complete'
    return 'upload'
}

function SignHearingLoss() {
    const [claimLoaded, setClaimLoaded] = useState(false)
    const [resumeStep, setResumeStep] = useState<'signature' | 'upload' | 'complete'>('signature')
    const [requesting, setRequesting] = useState(false)
    const [loadError, setLoadError] = useState(false)
    const { token } = useParams()
    const updateClaim = useUpdateClaimData()

    useEffect(() => {
        if (requesting || claimLoaded || loadError) return
        if (!token) {
            apiErrors('unknown')
            setLoadError(true)
            return
        }

        if (process.env.REACT_APP_MOCK_CLAIM === 'true') {
            updateClaim({
                caseRef: 'mock-case-ref',
                token,
                claimType: 'non-limitation',
                documentUrl: MOCK_PACK_DOCS[0].url,
                documents: MOCK_PACK_DOCS,
                clientName: 'John Smith',
                clientEmail: 'john.smith@example.com',
            })
            setClaimLoaded(true)
            return
        }

        setRequesting(true)

        axios
            .get(`${process.env.REACT_APP_API_HEARING_LOSS_FETCH}/${encodeURIComponent(token)}`)
            .then((response) => {
                const payload = response.data
                const data = payload?.sigData
                if (!data || payload?.success === false) {
                    throw new Error(payload?.error || 'Failed to load claim')
                }

                const documents = Array.isArray(data.documents)
                    ? data.documents
                    : Array.isArray(payload.documents)
                      ? payload.documents
                      : []

                updateClaim({
                    caseRef: data.case_ref,
                    token: data.token || payload.signing_token || token,
                    claimType: data.is_limitation ? 'limitation' : 'non-limitation',
                    documentUrl: data.doc_url || documents[0]?.url,
                    documents,
                    clientName: `${data.first_name || ''} ${data.last_name || ''}`.trim(),
                    clientEmail: data.email,
                    identity: payload.identity || data.identity,
                })
                setResumeStep(resumeGroup(payload))
                setClaimLoaded(true)
            })
            .catch((e) => {
                setLoadError(true)
                if (e.response) {
                    apiErrors(e.response.data)
                } else {
                    apiErrors('unknown')
                }
            })
    }, [token, requesting, claimLoaded, loadError, updateClaim])

    return (
        <div className={`${styles.pcpClaimFormContainer}`}>
            {/* Same logo and secure badge as the top of the landing page */}
            <BrandBar className={styles.brandBar} />
            {claimLoaded ? (
                <HearingLossSignForm initialGroup={resumeStep} />
            ) : (
                <FormPageLoading
                    title="Loading your documents"
                    message="Fetching your hearing loss claim pack…"
                />
            )}
        </div>
    )
}

export default SignHearingLoss
